import api from './axios';
import { authHeader, noContentTypeHeader } from '../helpers';
import { authService } from './authentication.service';

export const excelFormService = {
    generateForm,
    checkForm,
    getForm,
    getFormsByUtam,
    downloadForm,
    editForm,
    deleteForm,
    saveForm,
    submitForm,
    getFSDIgnoreValues
};

async function generateForm(formRequest) {
    return api.post('/formulaire/generer', formRequest, {
        headers: authHeader(),
        responseType: 'blob' // Required for handling file downloads
    })
        .then(response => {
            // Accéder aux en-têtes via response.headers (cas insensitive)
            const headers = response.headers;
            let contentDisposition = headers['content-disposition'] || headers['Content-Disposition'];
            let fileName = 'downloaded_file.xlsx'; // Nom par défaut

            // Vérifier si l'en-tête est présent et extraire le nom du fichier
            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?(.+?)"?;/i);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            const blob = response.data;
            const a = document.createElement('a');
            a.style.display = 'none';
            let url = null;

            if (window.navigator.msSaveOrOpenBlob) {
                a.onclick = () => {
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                };
            } else {
                url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = fileName;
            }

            document.body.appendChild(a);
            a.click();
            if (url) window.URL.revokeObjectURL(url);
            a.remove();

            return response.data;
        })
        .catch(async error => {
            if (error.response && error.response.data) {
                try {
                    const errorData = error.response.data instanceof Blob
                        ? JSON.parse(await error.response.data.text())
                        : error.response.data;
                    throw new Error(JSON.stringify(errorData));
                } catch (parseError) {
                    throw error;
                }
            }
            throw error;
        });
}

async function checkForm(file, fsdString = null) {
    const formData = new FormData();
    formData.append('file', file);

    return api.post(`/formulaire/verifier?fsdIgnoreString=${fsdString}`, formData, {
        headers: noContentTypeHeader(file.name)
    })
        .then(authService.handleResponse);
}

async function getForm(guid) {
    return api.get(`/Formulaire/guid/${guid}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getFormsByUtam(utam) {
    return api.get(`/Formulaire/utam/${utam}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function editForm(id, description, nomFichier) {
    return api.patch(`/Formulaire/${id}`, { description, nomFichier }, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteForm(id) {
    return api.delete(`/Formulaire/${id}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function downloadForm(guid) {
    return api.get(`/formulaire/download/${guid}`, {
        headers: authHeader(),
        responseType: 'blob' // Required for handling file downloads
    })
        .then(response => {
            const contentDisposition = response.headers['content-disposition'];
            const fileName = contentDisposition.match(/filename=(.+);/i)[1];

            const blob = response.data;
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();

            return response.data;
        })
        .catch(error => {
            if (error.response && error.response.data) {
                return Promise.reject(error.response.data);
            }
            return Promise.reject(error);
        });
}

async function submitForm(request, file) {
    const formData = new FormData();

    for (const key in request) {
        if (Array.isArray(request[key])) {
            request[key].forEach((v, i) => {
                formData.append(`${key}[${i}]`, v);
            });
        } else {
            if (typeof request[key] === 'object') {
                formData.append(key, JSON.stringify(request[key]));
            } else {
                formData.append(key, request[key]);
            }
        }
    }

    formData.append('formulaire', file);

    return api.post('/Formulaire/soumettre', formData, {
        headers: noContentTypeHeader(file.name)
    })
        .then(authService.handleResponse);
}

async function saveForm(request, file) {
    const formData = new FormData();

    for (const key in request) {
        if (Array.isArray(request[key])) {
            request[key].forEach((v, i) => {
                Object.keys(v).forEach(k => {
                    formData.append(`${key}[${i}].${k}`, v[k]);
                });
            });
        } else {
            if (typeof request[key] === 'object') {
                formData.append(key, JSON.stringify(request[key]));
            } else {
                formData.append(key, request[key]);
            }
        }
    }

    formData.append('contenu', file);

    return api.post('/Formulaire/creer', formData, {
        headers: noContentTypeHeader(file.name)
    })
        .then(authService.handleResponse);
}

async function getFSDIgnoreValues() {
    return api.get('/Formulaire/ignore', {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}
